import { useState } from 'react';

import { UpgradeModal } from './UpgradeModal';
import Button from '@components/atoms/button';
import Icon from '@components/atoms/icon';
import Tooltip from '@components/atoms/tooltip';
import { AnalyticsEvents, captureAnalyticsEvent } from '@lib/analytics/events';

export const MEMBERS_ONLY_TITLE = 'Available to FFHUB Members';

type LockedActionProps = {
  label: string;
  /** Feature name used in the upgrade modal copy, as it reads mid-sentence. */
  feature: string;
  /** Where this locked button sits, for the feature_locked_hit event. */
  placement: string;
  dataCy: string;
  className?: string;
};

/**
 * Padlocked stand-in for an action button a non-paying member cannot use.
 * Clicking it explains the feature is members-only rather than doing nothing.
 */
export const LockedAction = ({
  label,
  feature,
  placement,
  dataCy,
  className
}: LockedActionProps) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <Tooltip variant="dark" title={MEMBERS_ONLY_TITLE}>
        <Button
          variant="secondary"
          onClick={() => {
            // FFH-2373: hitting the lock is the demand signal for the gated
            // feature; the modal's own CTA fires upgrade_cta_clicked.
            captureAnalyticsEvent(AnalyticsEvents.featureLockedHit, {
              placement,
              feature
            });
            setIsModalOpen(true);
          }}
          dataCy={dataCy}
          className={className}
        >
          <span className="inline-flex items-center gap-2">
            <Icon name="Lock" />
            {label}
          </span>
        </Button>
      </Tooltip>
      <UpgradeModal
        isOpen={isModalOpen}
        feature={feature}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};
